export const TRANSCRIPT_UTTERANCES_CONTAINER_ID = 'transcriptUtterances';